import { useMemo } from "react";
import { TosVersion } from "../../entities/tosVersion";
import { useGetTosVersionsQuery } from "./tosVersionEndpoints";

/**
 *
 */
export function useTosVersions() {
  const tosVersionQuery = useGetTosVersionsQuery();
  const tosVersionEntitiesMap = tosVersionQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof tosVersionQuery & { tosVersions?: TosVersion[] } = {
      ...tosVersionQuery,
    };
    if (tosVersionEntitiesMap) {
      const tosVersions: TosVersion[] = [];
      for (const key in tosVersionEntitiesMap) {
        const entity = tosVersionEntitiesMap[key];
        if (entity) tosVersions.push(new TosVersion(entity));
      }
      ret.tosVersions = tosVersions;
    }
    return ret;
  }, [tosVersionQuery, tosVersionEntitiesMap]);
}
